<template>
    <div>

        <rkm-table
            :items="data.model.supervisores"
            :fields="fields.datatables.tipo"
            :filter="filter"
            sort-by="nome"
        >
            <template slot="filters">
                <rkm-row>
                    <rkm-col class="flex-grow-1">
                        <rkm-form-input
                            placeholder="Digite para buscar"
                            v-model="filter"
                        >
                            <rkm-input-group-prepend slot="prepend">
                                <rkm-input-group-text>Buscar</rkm-input-group-text>
                            </rkm-input-group-prepend>
                        </rkm-form-input>
                    </rkm-col>

                    <rkm-col class="flex-grow-0">
                        <rkm-button
                            :disabled="!filter"
                            @click="handleClearFilter"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="handleDestroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

export default {
    components: { Modal },
    computed: {
        fields() {

            return {
                datatables: {
                    tipo: [
                        { key: 'nome', label: 'Supervisor', sortable: true },
                        { key: 'cpf', label: 'CPF', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min' },
                    ],
                }
            }
        },
    },
    data: () => ({
        items: [],
        filter: null,
    }),
    methods: {
        handleDestroy(item) {

            const objId = this.data.model.supervisores.findIndex((obj => obj.id == item.id));

            const destroy = async () => this.data.model.supervisores.splice(objId, 1)

            this.showDeleteConfirmation(`Deseja realmente excluir o(a) supervisor(a) <strong>${ item.nome }</strong>?`, destroy)
        },
        handleClearFilter() {
            this.filter = null
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>